import { RootState } from "../rootStore";

export const selectSession = (state: RootState) => state.session;
export const selectLanguage = (state: RootState) => state.session.selectedLanguage;
export const selectAccessToken = (state: RootState) => state.session.accessToken;
